class ScrollToAnchor {
  getScrollOffset() {
    if (!this.$navbar || !this.$navbar.length) {
      this.$navbar = $(".navbar");
    }

    if (this.$navbar.css('position') === 'fixed') {
      return this.$navbar.height();
    } else {
      return 0;
    }
  }

  scrollTo(hash, time = 500) {
    let target;

    try {
      target = $(hash);
    } catch (e) {}

    if (target && target.length) {
      return $("html,body").animate({
        scrollTop: target.offset().top - this.getScrollOffset()
      }, time, (function() {
        if (history.pushState) {
          if (window.location.hash !== hash) { return history.pushState({
            location: {
              hash,
              pathname: location.pathname,
              href: location.href
            }
          }, null, hash); }
        } else {
          return window.location.hash = hash;
        }
      }));
    }
  }
};

st.ScrollToAnchor = new ScrollToAnchor();

$(document).on("click", ".js-scroll-to-anchor-link", function(event) {
  event.preventDefault();
  event.stopPropagation();
  return st.ScrollToAnchor.scrollTo(event.target.hash);
});



// WEBPACK FOOTER //
// ./app/webpack/frontend/common/jsScrollToAnchorLink.js